import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from './session-context';
import AppLayout from './work/AppLayout';

type Props = { children: ReactNode; roles?: string[]; orgAdmin?: boolean };

export default function ProtectedRoute({ children, roles, orgAdmin }: Props) {
  const { ready, email, roles: userRoles, orgRole } = useSession();

  if (!ready) {
    return (
      <AppLayout>
        <p className="text-sm text-muted-foreground">Loading...</p>
      </AppLayout>
    );
  }

  if (!email) {
    return <Navigate to="/login" replace />;
  }

  if (roles && roles.length > 0 && !roles.some((role) => userRoles.includes(role))) {
    return <Navigate to="/login" replace />;
  }

  if (orgAdmin && orgRole !== 'admin') {
    return <Navigate to="/settings/profile" replace />;
  }

  return <>{children}</>;
}
